const THEME_ON_CHANGE = 'THEME_ON_CHANGE';
const THINK_TOOL_TAB_TOGGLE = 'THINK_TOOL_TAB_TOGGLE';
const NEW_MESSAGE_COMPOSE_TOGGLE = 'NEW_MESSAGE_COMPOSE_TOGGLE';
const TL_USER_VERSION_TOGGLE = 'TL_USER_VERSION_TOGGLE';

const API_GET_CLIENT_BACKGROUND_REQUEST = 'API_GET_CLIENT_BACKGROUND_REQUEST';
const API_GET_CLIENT_BACKGROUND_SUCCESS = 'API_GET_CLIENT_BACKGROUND_SUCCESS';
const API_GET_CLIENT_BACKGROUND_FAILURE = 'API_GET_CLIENT_BACKGROUND_FAILURE';

const TOGGLE_COMPOSE_MESSAGE = 'TOGGLE_COMPOSE_MESSAGE';
const TOGGLE_VIEW_MESSAGE = 'TOGGLE_VIEW_MESSAGE';
const TOGGLE_THINKTOOL_POPUP = 'TOGGLE_THINKTOOL_POPUP';

const TOGGLE_ADD_PROGRAMME_POPUP = 'TOGGLE_ADD_PROGRAMME_POPUP';
const TOGGLE_DECLINE_INVITE_REASON_POPUP = 'TOGGLE_DECLINE_INVITE_REASON_POPUP';
const TOGGLE_DELETE_USER_POPUP = 'TOGGLE_DELETE_USER_POPUP';
const TOGGLE_ADD_USER_POPUP = 'TOGGLE_ADD_USER_POPUP';
const TOGGLE_ADD_USER_POPUP_SUCCESS = 'TOGGLE_ADD_USER_POPUP_SUCCESS';

const TOGGLE_USER_DASHBOARD = 'TOGGLE_USER_DASHBOARD';
const SAVE_EDIT_POPUP = 'SAVE_EDIT_POPUP';
const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION';
const RESET_NOTIFICATION = 'RESET_NOTIFICATION';
const TOGGLE_VIEW_ATTACH = 'TOGGLE_VIEW_ATTACH';
const TOGGLE_FOOTER_POPUP = 'TOGGLE_FOOTER_POPUP';
const TOGGLE_REFERER_PAGE = 'TOGGLE_REFERER_PAGE';
const RESET_USER = 'RESET_USER';

const TOGGLE_TOUR_POPUP = 'TOGGLE_TOUR_POPUP';

export const toggleFooterPopup = payload => ({
  type: TOGGLE_FOOTER_POPUP,
  payload,
});
export const resetUser = payload => ({
  type: RESET_USER,
  payload,
});

export const toggleViewAttach = payload => ({
  type: TOGGLE_VIEW_ATTACH,
  payload,
});

export const toggleSaveEditPopup = payload => ({
  type: SAVE_EDIT_POPUP,
  payload,
});

export const toggleThinkToolPopup = payload => ({
  type: TOGGLE_THINKTOOL_POPUP,
  payload,
});

export const toggleAddProgrammePopup = payload => ({
  type: TOGGLE_ADD_PROGRAMME_POPUP,
  payload,
});

export const toggleDeclineInviteReasonPopup = payload => ({
  type: TOGGLE_DECLINE_INVITE_REASON_POPUP,
  payload,
});

export const toggleAddUserPopup = payload => ({
  type: TOGGLE_ADD_USER_POPUP,
  payload,
});

export const toggleDeleteUserPopup = payload => ({
  type: TOGGLE_DELETE_USER_POPUP,
  payload,
});

export const toggleAddUserPopupSuccess = payload => ({
  type: TOGGLE_ADD_USER_POPUP_SUCCESS,
  payload,
});

export const toggleComposeMessage = payload => ({
  type: TOGGLE_COMPOSE_MESSAGE,
  payload,
});

export const toggleViewMessage = payload => ({
  type: TOGGLE_VIEW_MESSAGE,
  payload,
});


export const toggleNewMessageCompose = payload => ({
  type: NEW_MESSAGE_COMPOSE_TOGGLE,
  payload,
});

export const toggleThinkToolTab = payload => ({
  type: THINK_TOOL_TAB_TOGGLE,
  payload,
});

export const toggleTlUserVersion = payload => ({
  type: TL_USER_VERSION_TOGGLE,
  payload,
});

export const toggleUserDashboard = payload => ({
  type: TOGGLE_USER_DASHBOARD,
  payload,
});

export const toggleNotification = payload => ({
  type: TOGGLE_NOTIFICATION,
  payload,
});

export const resetNotification = () => ({
  type: RESET_NOTIFICATION,
});

export const toggleTourPopup = payload => ({
  type: TOGGLE_TOUR_POPUP,
  payload,
});

export const toggleRefererPage = payload => ({
  type: TOGGLE_REFERER_PAGE,
  payload,
});

const initialState = {
  refererPage: '/team-leader',
  isFooterPopup: false,
  notification: false,
  notificationMessage: '',
  notificationType: 'success',
  saveEditPopup: false,
  thinkToolPopup: false,
  addProgrammePopup: false,
  declineInviteReasonPopup: false,
  addUserPopup: false,
  deleteUserPopup: false,
  addUserPopupSuccess: false,
  composeMessage: false,
  viewMessage: false,
  clientBackground: null,
  clientBackgroundFetching: false,
  isLight: true,
  isOpenedThinkToolTab: false,
  isShowNewMessageCompose: false,
  isTlUserVersionsOpened: false,
  isUserDashboardOpened: false,
  isViewAttach: false,
  tourPopupFlag: false,
};

if (window.localStorage.getItem('isLight') !== null) {
  initialState.isLight = window.localStorage.getItem('isLight') === 'true';
}

if (window.localStorage.getItem('isLight') === null) {
  window.localStorage.setItem('isLight', initialState.isLight);
}

export const viewReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_REFERER_PAGE:
      return {
        ...state,
        refererPage: action.payload,
      };
    case RESET_USER:
        return {
          ...state,
          addUserPopupSuccess: null,
        };
    case TOGGLE_FOOTER_POPUP:
      return {
        ...state,
        isFooterPopup: action.payload,
      };
    case TOGGLE_VIEW_ATTACH:
      return {
        ...state,
        isViewAttach: action.payload,
      };
    case RESET_NOTIFICATION:
      return {
        ...state,
        notification: false,
      };
    case TOGGLE_NOTIFICATION:
      return {
        ...state,
        notification: action.payload.value,
        notificationMessage: action.payload.message,
        notificationType: action.payload.type,
      };
    case SAVE_EDIT_POPUP:
      return {
        ...state,
        saveEditPopup: action.payload,
      };
    case TOGGLE_THINKTOOL_POPUP:
      return {
        ...state,
        thinkToolPopup: action.payload,
      };
    case TOGGLE_ADD_PROGRAMME_POPUP:
      return {
        ...state,
        addProgrammePopup: action.payload,
      };
    case TOGGLE_DECLINE_INVITE_REASON_POPUP:
      return {
        ...state,
        declineInviteReasonPopup: action.payload,
      };
    case TOGGLE_ADD_USER_POPUP:
      return {
        ...state,
        addUserPopup: action.payload,
      };
    case TOGGLE_DELETE_USER_POPUP:
      return {
        ...state,
        deleteUserPopup: action.payload,
      };
    case TOGGLE_ADD_USER_POPUP_SUCCESS:
      return {
        ...state,
        addUserPopupSuccess: action.payload,
      };
    case TOGGLE_COMPOSE_MESSAGE:
      return {
        ...state,
        composeMessage: action.payload,
      };
    case TOGGLE_VIEW_MESSAGE:
      return {
        ...state,
        viewMessage: action.payload,
      };
    case API_GET_CLIENT_BACKGROUND_FAILURE:
      return {
        ...state,
        clientBackgroundFetching: false,
        error: action.payload,
      };
    case API_GET_CLIENT_BACKGROUND_SUCCESS:
      return {
        ...state,
        clientBackground: action.payload,
        clientBackgroundFetching: false,
      };
    case API_GET_CLIENT_BACKGROUND_REQUEST:
      return {
        ...state,
        clientBackgroundFetching: true,
      };
    case NEW_MESSAGE_COMPOSE_TOGGLE:
      return {
        ...state,
        isShowNewMessageCompose: action.payload,
      };
    case THINK_TOOL_TAB_TOGGLE:
      return {
        ...state,
        isOpenedThinkToolTab: action.payload,
      };
    case THEME_ON_CHANGE:
      window.localStorage.setItem('isLight', !state.isLight);
      return {
        ...state,
        isLight: !state.isLight,
      };
    case TL_USER_VERSION_TOGGLE:
      return {
        ...state,
        isTlUserVersionsOpened: action.payload,
      };
    case TOGGLE_USER_DASHBOARD:
      return {
        ...state,
        isUserDashboardOpened: action.payload,
      };
    case TOGGLE_TOUR_POPUP:
      return {
        ...state,
        tourPopupFlag: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/view.js